@if ((consentsTranslations$ | async);as consentsTranslations) {
  @if (extendedCookieBanner$ | async) {
    <app-extended-cookie-consent [consentsTranslations]="consentsTranslations"/>
  } @else {
    <app-simple-cookie-consent [consentsTranslations]="consentsTranslations"/>
  }
}
